import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const faqs = [
  {
    q: 'What cities do you serve?',
    a: "I cover the entire Puget Sound region — Tacoma, Seattle, Lakewood, Bellevue, Puyallup, Kent, Renton, Auburn, Federal Way, University Place, Gig Harbor, Bonney Lake, Des Moines, Normandy Park, West Seattle, Black Diamond, Olympia, Lacey, and every city across Pierce and King County.",
  },
  {
    q: 'Do you work with first-time home buyers?',
    a: "Yes. First-time buyers are a significant part of my practice. I walk you through financing, pre-approval, the offer process, inspections, appraisal, and closing — and I never pressure you into a home that isn't right.",
  },
  {
    q: 'Are you experienced with VA loans and military relocation?',
    a: "Yes. My office is in Lakewood, minutes from Joint Base Lewis-McChord. I regularly help service members and veterans with VA loan transactions, PCS timelines, and the logistics of moving into or out of Western Washington.",
  },
  {
    q: 'Do you help with Adult Family Home sales?',
    a: "Yes — Adult Family Homes are a specialized niche involving licensing, zoning, and investor valuation. I represent both buyers and sellers of licensed AFHs across Pierce and King County.",
  },
  {
    q: 'What makes you different from other real estate agents?',
    a: "I bring a scientific background to every transaction — I was trained in molecular biology before entering real estate. That means precision on contract details, disciplined pricing analysis, and a commitment to treating every decision like it matters — because it does.",
  },
  {
    q: 'How do I get started?',
    a: "Call or text (253) 315-9480, or send me a message through the contact form. Initial consultations are free and no-pressure — we'll talk about your goals, timeline, and whether working together makes sense.",
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

const FAQSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-24 bg-white">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-xs tracking-[0.3em] text-gray-500 uppercase mb-3">Frequently Asked</p>
          <h2 className="text-3xl md:text-4xl font-light text-gray-900">
            Questions Clients Ask Me
          </h2>
          <div className="w-16 h-[1px] bg-gray-300 mx-auto mt-5" />
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="border border-gray-200 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left hover:bg-gray-50 transition-colors"
                  aria-expanded={isOpen}
                >
                  <span className="text-base font-medium text-gray-900">{f.q}</span>
                  {isOpen ? (
                    <Minus size={18} className="text-gray-500 flex-shrink-0" />
                  ) : (
                    <Plus size={18} className="text-gray-500 flex-shrink-0" />
                  )}
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 pt-1 text-sm text-gray-600 leading-relaxed">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
